import React, { useEffect } from 'react'
import { Btn, CustomCheckbox, CustomModal, InputText, SectionTitle } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import useCadastroInsumoModal, { FIELDS_NAMES, LOADING_MESSAGES } from './CadastroInsumoModalHook'

function CadastroInsumoModal({ visible = false, selectedInsumo = null, onResponse }) {
  const { state, localDispatch } = useCadastroInsumoModal()

  // Hooks
  useEffect(() => {
    visible && selectedInsumo && localDispatch.onStart(selectedInsumo)
  }, [visible])

  useEffect(() => {
    if (state.errorMessage) {
      onResponse('error', state.errorMessage)
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.loadingMessage === LOADING_MESSAGES.SAVE) {
      localDispatch.saveInsumo(state.insumo)
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.savedInsumo) {
      onResponse('success', state.savedInsumo)
      localDispatch.resetState()
    }
  }, [state.savedInsumo])
  // Helpers

  // Render
  return (
    <CustomModal
      width={600}
      header={selectedInsumo && selectedInsumo.id ? 'Editar - Insumo' : 'Novo Insumo'}
      isVisible={visible}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-8">
          <InputText
            label={'Insumo'}
            value={state.insumo ? state.insumo.name : ''}
            onChange={value => localDispatch.onFormChange(FIELDS_NAMES.INSUMO_NAME, value)}
          />
        </div>
        <div className="p-col-4">
          <InputText
            label={'Unidade de Movimentação'}
            value={state.insumo ? state.insumo.unidadeMovimentacao : ''}
            onChange={value => localDispatch.onFormChange(FIELDS_NAMES.UNI_MOVIMENTACAO, value)}
          />
        </div>
        <div className="p-col-12">
          <SectionTitle title={'Operações que irão movimentar o Insumo'} />
        </div>
        <div className="p-col-12">
          <DataTable
            value={selectedInsumo ? selectedInsumo.allowedTps : []}
            rows={5}
            paginator={true}
          >
            <Column
              header={'#'}
              body={item => (
                <CustomCheckbox
                  checked={item.active}
                  onChange={() => localDispatch.onCheckboxClick(item)}
                />
              )}
              style={tableCellCentered()}
            />
            <Column field={'name'} header={'Operação Logística'} />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn
            onClick={localDispatch.onBtnSalvar}
            isLoading={state.loadingMessage === LOADING_MESSAGES.SAVE}
          >
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default CadastroInsumoModal
